import { ActionTree } from 'vuex';
import { IShareConfigState } from './types';
import { IRootState } from '../types';
import { IUserNode } from '../nodes/types';
import shareConfig from '../../queries/shareConfig.gql';
import activeLicenseCount from '../../queries/activeLicenseCount.gql';

export const actions: ActionTree<IShareConfigState, IRootState> = {
  async fetchShareConfig({ commit, dispatch }) {
    try {
      if (this.app.apolloProvider) {
        commit('setFetching', true);
        dispatch('fetchUserNodeLicenseCount');

        const client = this.app.apolloProvider.defaultClient;

        const shareConfigResults = await client.query({
          query: shareConfig,
          fetchPolicy: 'network-only',
        });

        const {
          data: { galaShareConfig: shareConfigData },
        } = shareConfigResults;

        commit('setShareConfig', { ...shareConfigData });
        commit('setFetching', false);
      }
    } catch (error) {
      this.$sentry.captureException(error);
      commit('setFetching', false);
      console.warn(error);
    }
  },

  async fetchUserNodeLicenseCount({ commit }) {
    try {
      if (this.app.apolloProvider) {
        const gatewayClient = this.app.apolloProvider.clients.gateway;

        const userNodeLicenseCounts = await gatewayClient.query({
          query: activeLicenseCount,
          fetchPolicy: 'network-only',
        });

        const filmNodes =
          userNodeLicenseCounts.data.activeLicenseCount.all.find(
            (item: Omit<IUserNode, 'name'>) =>
              item.licenseName === 'film-license',
          );

        const shareConfigData = {
          founderNodesOwned:
            userNodeLicenseCounts.data.activeLicenseCount.founder,
          townstarNodesOwned:
            userNodeLicenseCounts.data.activeLicenseCount.townstar,
          filmNodesOwned: filmNodes?.quantity || 0,
        };

        commit('setNodesOwned', shareConfigData);
      }
    } catch (error) {
      this.$sentry.captureException(error);
      console.warn(error);
    }
  },
};
